@if (showTrigger()) {
  <se-fe-modal-button [seFeDataButton]="{icon: true}" (seFeButtonAction)="open($event)">
    <se-fe-icon
      seFeModalIcon
      seFeDataName="pencil_fill"
      seFeDataSize="500"
      seFeDataColor="default"
      seFeDataAriaLabel="edit"></se-fe-icon>
  </se-fe-modal-button>
}

<se-fe-modal seFeDataSize="large" #variantModal (seFeAfterClose)="resetForm()">
  <div seFeModalHeader>
    <se-fe-modal-header seFeDataTitle="Edit Product variants"></se-fe-modal-header>
  </div>

  <se-fe-modal-content>
    @if (variantModal.isOpen || variantModal.closing) {
      <form [formGroup]="specForm()" novalidate>
        @for (spec of specOptions(); track spec.id; let index = $index) {
          <div class="spec-options">
            <se-fe-form-field [seFeDataConfig]="spec.label"></se-fe-form-field>
            <se-fe-form-field-multiselect
              [seFeTooltipTrigger]="displayTooltip(spec.label.label) ? tooltip : null"
              seFeDataPosition="bottom"
              class="spec-options__select"
              id="{{ spec.label.label }}"
              formControlName="{{ spec.label.label }}"
              [seFeDataOptions]="spec.selectControl"
              [seFeDataListView]="true"
              [seFeDataEnableAddNew]="true"
              [seFeDataHideSearchIcon]="true"
              [seFeDataPlaceholder]="getSelectPlaceholderText(spec.label.label)"
              [seFeDataQueryValidators]="specsMaxLengthValidator"
              [seFeDataQueryConfig]="specsValidationConfig"
              [seFeDataReadonly]="readonlySpecs()[spec.label.label]"
              seFeDataNotFoundMessage="Not found, press enter to add the item to the list"
              [seFeDataComfy]="true"></se-fe-form-field-multiselect>
            <p class="spec-options__instruction">
              Enter or choose any {{ spec.label.label.toLocaleLowerCase() }} that you offer this product in and we'll
              automatically create the variants for you.
            </p>
            <se-fe-tooltip #tooltip>
              You can’t add any more {{ spec.label.label.toLocaleLowerCase() }} because it would create more than the
              limit of {{ MAX_ALLOWED_VARIANTS }} total product variants.
            </se-fe-tooltip>
          </div>
        }
      </form>
    }

    @if (optionRemovalWarnings().length > 0) {
      <div class="option-removal-warnings">
        <span>{{ optionRemovalLabel() }}</span>
        <ul class="option-removal-warnings__list">
          @for (variant of optionRemovalWarnings(); track variant) {
            <li>{{ variant }}</li>
          }
        </ul>
      </div>
    }

    <div>
      <se-fe-table-wrapper>
        <form [formGroup]="variantsForm()">
          <table seFeTable seFeTableSort title="Product variants" [dataSource]="skuDatasource()">
            <ng-container seFeColumnDef="name">
              <th seFeDataRef="name" seFeTableSortHeader seFeHeaderCell *seFeHeaderCellDef>Variant</th>
              <td seFeCell *seFeCellDef="let row">{{ row.name }}</td>
            </ng-container>
            <ng-container seFeColumnDef="sku">
              <th seFeDataRef="name" seFeTableSortHeader seFeHeaderCell *seFeHeaderCellDef>SKU</th>
              <td seFeCell *seFeCellDef="let row">
                <se-fe-form-field [seFeDataConfig]="skuFormFieldConfig" class="sku-field">
                  <se-fe-form-field-text [formControlName]="row.id" [seFeDataComfy]="false"></se-fe-form-field-text>
                </se-fe-form-field>
              </td>
            </ng-container>
            <tr seFeHeaderRow *seFeHeaderRowDef="variantTableColumns"></tr>
            <tr seFeRow *seFeRowDef="let row; columns: variantTableColumns"></tr>
          </table>
        </form>
      </se-fe-table-wrapper>
    </div>

    @if (error()) {
      <se-fe-alert seFeDataType="error">{{ error() }}</se-fe-alert>
    }
    <div class="specs-modal-footer">
      <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="isSaving" (click)="closeModal()">Cancel</se-fe-button>
      <se-fe-button
        seFeDataEmphasis="high"
        [seFeDataIsLoading]="isSaving"
        [seFeDataIsDisabled]="isSaving"
        (click)="saveProductSpecs()">
        Save
      </se-fe-button>
    </div>
  </se-fe-modal-content>
</se-fe-modal>
